import { z } from 'zod';
import { documentSummarySchema } from '@/features/documents';
import { getJson } from '@/shared/api/client';
import { pageSchema } from '@/shared/api/page';

const facetSchema = z.object({ value: z.string(), count: z.number().int() });
export const facetsSchema = z.object({
  assetClasses: z.array(facetSchema),
  currencies: z.array(facetSchema),
  analysts: z.array(facetSchema),
  coverage: z.object({ from: z.string(), to: z.string(), total: z.number().int() }),
});
export type Facets = z.infer<typeof facetsSchema>;

export type LibraryParams = {
  page: number;
  pageSize: number;
  q: string;
  assetClass: string;
  currency: string;
  analyst: string;
  from: string;
  to: string;
  /** With a search: '' (most relevant first, the default) or 'newest'. */
  sort: string;
};

const searchResultSchema = documentSummarySchema.extend({ snippet: z.string().nullable() });
export type SearchResult = z.infer<typeof searchResultSchema>;

/** Blank filters are dropped so the URL, query key and request stay identical. */
const compact = (p: LibraryParams) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== ''));

export const fetchDocuments = (params: LibraryParams, signal?: AbortSignal) =>
  getJson('/documents', pageSchema(searchResultSchema), { params: compact(params), ...(signal ? { signal } : {}) });

export const fetchFacets = (signal?: AbortSignal) => getJson('/documents/facets', facetsSchema, signal ? { signal } : {});
